import React, { FC } from 'react';
import { H4 } from 'components/Typography';
import UberEATS from 'assets/images/brands/ubereats.svg';
import DoorDash from 'assets/images/brands/doordash.svg';
import GrubHub from 'assets/images/brands/grubhub.png';
import PostMates from 'assets/images/brands/postmates.png';
import {
  Modal,
  Content,
  TwoColumnGrid,
  TitleWithUnderline,
  SubTitleWithUnderline,
  CommentText,
  Wrap,
  DetailsContainer,
  NarrowContainer,
  TopContent,
  TitleWithUnderlineWhite,
  SubTitleWithUnderlineWhite,
  ReportText,
  BlockTitle,
  BlockTitleContainer,
  TitleLine,
  Logo,
} from './styles';
import { Props } from './types';

const PaymentModal: FC<Props> = ({ modalContent, handleClose }) => {
  const deliveryBrands: any = {
    grubhub: {
      name: 'GrubHub',
      logo: GrubHub,
    },
    ubereats_manager: {
      name: 'UberEATS',
      logo: UberEATS,
    },
    doordash: {
      name: 'DoorDash',
      logo: DoorDash,
    },
    post_mates: {
      name: 'PostMates',
      logo: PostMates,
    },
  };

  return (
    <Modal open={Boolean(modalContent)} handleClose={handleClose}>
      <TopContent>
        <BlockTitleContainer>
          <BlockTitle>{modalContent?.brandName.name}</BlockTitle>
          <TitleLine />
        </BlockTitleContainer>
        <ReportText>
          <H4>Report For:</H4>
          <H4>{modalContent?.comments}</H4>
        </ReportText>
        <TwoColumnGrid>
          {/* Total */}
          <TitleWithUnderlineWhite>Total:</TitleWithUnderlineWhite>
          <TitleWithUnderlineWhite>
            {modalContent?.total}
          </TitleWithUnderlineWhite>
        </TwoColumnGrid>
        <NarrowContainer>
          <TwoColumnGrid>
            {/* Subtotal */}
            <SubTitleWithUnderlineWhite>Other fees:</SubTitleWithUnderlineWhite>
            <SubTitleWithUnderlineWhite>
              {0}
              {/* {modalContent?.total} */}
            </SubTitleWithUnderlineWhite>

            {/* Tax */}
            <H4>Hardware Rental:</H4>
            <H4>
              {0}
              {/* {modalContent?.total} */}
            </H4>
          </TwoColumnGrid>
        </NarrowContainer>
      </TopContent>
      <DetailsContainer>
        <BlockTitleContainer style={{ paddingLeft: '2.9rem' }}>
          <BlockTitle>Details per service</BlockTitle>
          <TitleLine />
        </BlockTitleContainer>
        {modalContent &&
          modalContent.integrations
            .filter((item) => deliveryBrands[item.integrationId] !== undefined)
            .map((item) => (
              <Content>
                <Wrap>
                  <Logo
                    src={deliveryBrands[item.integrationId].logo}
                    alt={deliveryBrands[item.integrationId].name}
                  />
                </Wrap>
                <div />
                <TwoColumnGrid>
                  {/* Total */}
                  <TitleWithUnderline>Total:</TitleWithUnderline>
                  <TitleWithUnderline>{item?.net}</TitleWithUnderline>
                </TwoColumnGrid>
                <NarrowContainer>
                  <TwoColumnGrid>
                    {/* Subtotal */}
                    <SubTitleWithUnderline>SubTotal:</SubTitleWithUnderline>
                    <SubTitleWithUnderline>
                      {item?.subtotal}
                    </SubTitleWithUnderline>

                    {/* Tax */}
                    <SubTitleWithUnderline>Tax:</SubTitleWithUnderline>
                    <SubTitleWithUnderline>{item?.tax}</SubTitleWithUnderline>

                    {/* Platform Payout */}
                    <SubTitleWithUnderline>
                      {deliveryBrands[item.integrationId].name} Payout:
                    </SubTitleWithUnderline>
                    <SubTitleWithUnderline>
                      {item?.platformPayout}
                    </SubTitleWithUnderline>

                    {/* Total net payout */}

                    <H4>Total Net Payout:</H4>
                    <H4>{item?.net}</H4>
                  </TwoColumnGrid>
                </NarrowContainer>
                {/* Comments - payment date etc. */}
                <CommentText>{item.comments}</CommentText>
              </Content>
            ))}
      </DetailsContainer>
    </Modal>
  );
};

export default PaymentModal;
